export enum EventShowTabsEnum {
  GENERAL = 'general',
  DISCUSSION = 'discussion',
  MEDIA = 'media',
  PARTICIPANTS = 'participants',
  AWARDS = 'awards',

}
